import React, { Component } from 'react';
import DonateButtonPreview from './DonateButtonPreview';
import ImageButtonPreview from './ImageButtonPreview';
import PropTypes from 'prop-types';
import getLocaleMessages from '../../utils/localesMessages';

const {
	previewContainerHeader
} = getLocaleMessages('buttons/wizardStepOne');

class ButtonPreviewContainer extends Component {
	static propTypes = {
		usePaypalButtonStyle: PropTypes.bool,
		buttonSize: PropTypes.string,
		showAcceptedCardLogos: PropTypes.bool,
		locale: PropTypes.string,
		country: PropTypes.string,
		language: PropTypes.string,
		buttonImageUrl: PropTypes.string,
		onError: PropTypes.func,
		buttonLocaleUrls: PropTypes.object,
	}

	render() {
		return (
			<div className="button-preview-container">
				<div className="header">
					<h3 className="vx_text-3">{previewContainerHeader}</h3>
				</div>

				<div className="button-preview">
					{
						this.props.usePaypalButtonStyle ?
						<DonateButtonPreview
							showAcceptedCardLogos={!!this.props.showAcceptedCardLogos}
							buttonSize={this.props.buttonSize}
							locale={this.props.locale}
							country={this.props.country}
							buttonLocaleUrls={this.props.buttonLocaleUrls}
						/> :
						<ImageButtonPreview
							buttonImageUrl={this.props.buttonImageUrl}
							onError={this.props.onError}
						/>
					}
				</div>
			</div>
		);
	}
}
export default ButtonPreviewContainer;



// WEBPACK FOOTER //
// ./buttons/components/buttonPreview/ButtonPreviewContainer.js